export const LOCAL_HOSTNAMES: string[] = ['localhost', '127.0.0.1'];
export const STAGING_HOSTNAMES: string[] = [
  'staging.color.com',
  'home.staging.color.com',
  'home.use1-a.eks.staging.color.com',
  'clinical.staging.color.com',
  'staging-clinical-web.monoweb.svc.cluster.local',
  'genomics-stb.joinallofus.org',
  'gp-staging.use1-a.eks.staging.color.com',
  'rhp-staging.use1-a.eks.staging.color.com',
  'aou-pdf.use1-a.eks.staging.color.com',
  'color-hub.use1-a.eks.staging.color.com',
  'hub.staging.color.com',
];
export const TESTING_HOSTNAMES: string[] = ['gp-testing.use1-a.eks.staging.color.com'];
export const PRODUCTION_HOSTNAMES: string[] = [
  'home.color.com',
  'home.use1-a.eks.color.com',
  'clinical.color.com',
  'prod-clinical-web.monoweb.svc.cluster.local',
  'genomics.joinallofus.org',
  'joinallofus.org',
  'rhp.aou.color.com',
  'aou-pdf.use1-a.eks.color.com',
  'hub.color.com',
];
